import {
    ASSIGN_PLANS_LOADING,
    ASSIGN_PLANS_SUCCESS,
    ASSIGN_PLANS_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    data: null,
    error: null,
  };
  
  export const assignPlansReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case ASSIGN_PLANS_LOADING:
        return { ...state, loading: true, error: null };
      case ASSIGN_PLANS_SUCCESS:
        return { ...state, loading: false, data: action.payload };
      case ASSIGN_PLANS_FAILED:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  